import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const AboutSection = () => {
  const [data, setData] = useState({
    id: 0,
    displayesInID: 0,
    title: "",
    description: "",
    imagePath: "",
  });

  // const fetchData = async () => {
  //   try {
  //     const response = await corefetch(
  //       "WelcomeSection/GetAboutSectionList?displayesInID=1"
  //     );
  //     if (response && response.length > 0) {
  //       const bannerData = response[0];
  //       setData({
  //         id: bannerData.id,
  //         displayesInID: bannerData.displayesInID,
  //         title: bannerData.title,
  //         description: bannerData.description,
  //         imagePath: bannerData.imagePath,
  //       });
  //     } else {
  //       setData([]);
  //     }
  //   } catch (error) {
  //     setData([]);
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const fetchData = async () => {
    try {
      const response = await corefetch(
        "WelcomeSection/GetAboutSectionList?displayesInID=1"
      );
      if (response && response.length > 0) {
        const bannerData = response[0];
        setData({
          id: bannerData.id,
          displayesInID: bannerData.displayesInID,
          title: bannerData.title,
          description: bannerData.description,
          imagePath: bannerData.imagePath,
        });

        const preloadLink = document.createElement("link");
        preloadLink.rel = "preload";
        preloadLink.as = "image";
        preloadLink.href = `${ImageURL}${bannerData.imagePath}`;
        document.head.appendChild(preloadLink);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!data || data.length == 0) {
    return null;
  }

  return (
    <>
      {data && (
        <section className="wpo-about-section sec-padding">
          <div className="container">
            <div className="wpo-about-wrap">
              <div className="row">
                <div className="col-lg-6 col-md-12 col-12">
                  <div
                    className="wpo-about-item wow fadeInLeftSlow"
                    data-wow-duration="1500ms"
                  >
                    <div className="wpo-about-img about">
                      <img
                        src={`${ImageURL}${data.imagePath}`}
                        alt="About Meridian"
                        width="600"
                        height="400"
                        loading="eager"
                        fetchpriority="high"
                      />
                    </div>
                  </div>
                </div>
                <div id="AboutMeridian" className="col-lg-6 col-md-12 col-12">
                  <div
                    className="wpo-about-text wow fadeInRightSlow"
                    data-wow-duration="1600ms"
                  >
                    <h2>{data.title}</h2>
                    <p>{data.description}</p>
                    <a href="/About-us" className="theme-btn">
                      Read more
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default AboutSection;
